import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../../actions";
import strings from "../../../helpers/Localization";
import { withRouter } from "react-router-dom";

//CUSTOM COMPONENT
import Area from "../../../aGlobalDesign/Area/Area";
import PaginationList from "../../../aGlobalDesign/Pagination/PaginationList";
import Modal from "../../../aGlobalDesign/Modal/Modal";
import ButtonSkaRound from "../../../aGlobalDesign/Buttons/ButtonSkaRound";

class DecisionTreesList extends React.Component {

    constructor() {
        super();
        this.state = {
            searchField: "",
            selectedDecisionTree: null,
            restrictedZones: null,
            temporaryElement: null,
            forcePaginationUpdate: 0
        };
    }
    componentDidMount() {
        this.props.changeAppBarTitle(strings.DecisionTrees);
        this.props.ChangeCurrentMenuName("DecisionTrees");

        this.props.GetRestrictedZones((data) => {
            this.setState({
                restrictedZones: data
            });
        });

        this.GetZoneList(() => {});
        if (!this.props.monitoring.secondarycallcenters) {
            this.props.GetSecondaryCallCentersList((data) => {});
        }
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedDecisionTree: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.reload && this.props.reload !== prevProps.reload) {
            this.forcePaginationUpdate();
        }
        if (this.props.createNew !== prevProps.createNew) {
            this.OnLoad(null);
        }
    }

    //#region functions
    OnLoad(decisionTree) {
        const url = "/Gestion/DecisionTree?id=" + (decisionTree ? decisionTree.id : 0);
        this.props.history.push(url);
    }
    OnOpenDecisionTreeDialog(decisionTree) {
        let d = decisionTree;

        if (d === null) {
            const zones = this.state.restrictedZones;
            const zoneId = zones.results.length > 0 && this.props.currentuser.accessrights.hasPermission(70, "create") === 20 ? zones.results[0].id : null;
            const orgId = this.props.currentuser.currentorganization.id;
            const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;
            const callCenterId = this.props.currentuser.accessrights.hasPermission(75, "modify") === 20 ? cucallCenterId : null;

            d = {
                id: 0,
                name: "",
                description: "",
                branches: [],
                timestamp: null,
                organizationId: this.props.currentuser.currentorganization.id,
                zoneId: zoneId,
                callCenterId: callCenterId
            };
        }
        const temp = this.CreateTemp(d);
        this.setState({
            selectedDecisionTree: d,
            temporaryElement: temp
        });
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            name: element.name,
            description: element.description,
            zoneId: element.zoneId,
            callCenterId: element.callCenterId
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.name = temp.name;
        element.description = temp.description;
        element.zoneId = temp.zoneId;
        element.callCenterId = temp.callCenterId;
        return element;
    }

    OnDelete(id, onSuccess) {
        this.props.OpenDialog({
            title: strings.deleteConfirm,
            description: strings.textDeleteDecisionTree,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmDelete,
            onPrimaryAction: () => {
                this.props.DeleteDecisionTree(id, () => {
                    this.forcePaginationUpdate();
                });
            }
        });
    }
    saveSelectedDecisionTree() {
        const display = this.state.selectedDecisionTree;
        this.SaveTemp(this.state.temporaryElement, display);
        if ( display.name === "") {
            this.props.OpenDialog({
                description: strings.alertName,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        const d = {
            id: display.id,
            name: display.name,
            description: display.description,
            zoneId: display.zoneId,
            callCenterId: display.callCenterId,
            organizationId: this.props.currentuser.currentorganization.id,
            timestamp: display.timestamp
        };

        if (display.id === 0) {
            this.props.CreateDecisionTree(d,
                (id) => {
                    const url = "/Gestion/DecisionTree?id=" + id;
                    this.props.history.push(url);
                });
        }
        else {
            this.props.EditDecisionTree([],
                d,
                (updatedDisplayTimestamp) => {
                    this.forcePaginationUpdate();
                }
            );
        }
    }
    GetZoneList(onSuccess) {
        if (this.props.administration.secondaryzones) {
            onSuccess(this.props.administration.secondaryzones);
        }
        else {
            this.props.GetSecondaryZonesList((data) => {
                onSuccess(data);
            });
        }
    }
    GetNonAttributedZones(list) {
        const temp = {};
        if (list && list.results) {
            const newlist = [];
            list.results.forEach(z => {
                if (z.decisionTrees !== null && z.decisionTrees !== undefined && z.decisionTrees.length > 0 && z.decisionTrees[0].id !== this.state.selectedDecisionTree.id) {
                    //there is already another decisiontree linked to this -> we cannot link it to this one.
                }
                else {
                    newlist.push(z);
                }
            });
            temp.results = newlist;
        }
        return temp;
    }
    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : {};

        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}

                onGetElements={this.props.GetDecisionTreesList}
                onSavePagination={this.props.SaveDecisionTreesPagination}
                myElements={this.props.monitoring.decisiontrees}

                sortOptions={[
                    { sortName: "name", sortData: "asc" },
                    { sortName: "description", sortData: "null" },
                    { sortName: "zone", sortData: "null" }
                ]}

                tableElement={(element) => {
                    return [
                        {
                            colTitle: strings.SortName,
                            sortIndex: 0,
                            fixedWidth: "300px",
                            colContent: element ? element.name : null
                        },
                        {
                            colTitle: strings.Description,
                            sortIndex: 1,
                            fixedWidth: "300px",
                            colContent: element ? element.description : null
                        },
                        {
                            colTitle: strings.SortZones,
                            sortIndex: 2,
                            fixedWidth: "300px",
                            colContent: element && element.zone ? element.zone.name : null
                        },
                        {
                            colTitle: strings.actions,
                            colType: "actions",
                            actions: [1, 2, 3],
                            colContent: [
                                <ButtonSkaRound
                                    key={"settings"}
                                    type="primary"
                                    onClick={() => this.OnLoad(element)}
                                    nameIcon="settings"
                                />,
                                <ButtonSkaRound
                                    key={"edit"}
                                    type="primary"
                                    onClick={() => this.OnOpenDecisionTreeDialog(element)}
                                    nameIcon="edit"
                                />,
                                <ButtonSkaRound
                                    key={"trash"}
                                    isDisabled={!accessrights || accessrights.hasPermission(70, "delete") <= 10}
                                    type="primary"
                                    onClick={() => this.OnDelete(element.id)}
                                    nameIcon="trash"
                                />

                            ]
                        }
                    ];
                }}
            />
            <Modal open={this.state.selectedDecisionTree !== null}
                onClose={() => this.forcePaginationUpdate()}
                title={this.state.selectedDecisionTree && this.state.selectedDecisionTree.id !== 0 ? strings.editDecisionTree : strings.CreateNewDecisionTree}
                icon={this.state.selectedDecisionTree && this.state.selectedDecisionTree.id !== 0 ? "edit" : "add"}
                disableValidate={!this.state.temporaryElement || !this.state.temporaryElement.callCenterId}
                fields={
                    this.state.temporaryElement ? [
                        {
                            type: "textfield",
                            title: strings.name,
                            placeholder: strings.name,
                            value: this.state.temporaryElement.name,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.name = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        },
                        {
                            type: "textfield",
                            title: strings.descriptif,
                            placeholder: "",
                            value: this.state.temporaryElement.description,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.description = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        },
                        {
                            type: "selectElement",
                            title: strings.Zone,
                            openTop: true,
                            adjustHeight: true,
                            elementsList: this.props.administration.secondaryzones ? this.GetNonAttributedZones(this.props.administration.secondaryzones) : null,
                            selectedElementId: this.state.temporaryElement.zoneId,
                            onSelectElement: (element) => {
                                const temp = this.state.temporaryElement;

                                if (element && accessrights.hasPermission(70, "modify") === 20) {
                                    const zindex = this.state.restrictedZones.results.findIndex(z => z.id === element.id);
                                    if (zindex < 0) {return;}
                                }

                                temp.zoneId = element ? element.id : null;
                                temp.zone = element;
                                this.setState({ temporaryElement: temp });
                            }
                        },
                        {
                            type: "selectElement",
                            title: strings.DefaultCC,
                            openTop: true,
                            elementsList: this.props.monitoring.secondarycallcenters,
                            selectedElementId: this.state.temporaryElement.callCenterId,
                            onSelectElement: (element) => {
                                const temp = this.state.temporaryElement;

                                if (accessrights.hasPermission(75, "modify") === 20) {
                                    const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;
                                    if (element && element.id !== cucallCenterId) {return;}
                                }

                                temp.callCenterId = element ? element.id : null;
                                this.setState({ temporaryElement: temp });
                            }
                        }
                    ] : null
                }
                onValidate={this.state.selectedDecisionTree && this.state.selectedDecisionTree.id === 0 || accessrights && accessrights.hasPermission(70, "modify") > 10 ? () => this.saveSelectedDecisionTree() : null }
            />
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default withRouter(connect(
    (state) => state,
    mapDispatchToProps
)(DecisionTreesList));
